import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import "./TableButtons.css";

/**
 * DeleteRowButton - Trash icon button for deleting table row
 * 
 * @example
 * <DeleteRowButton onClick={handleDelete} disabled={hasReferences} />
 */
const DeleteRowButton = ({ onClick, disabled = false, ariaLabel = "Delete row", ...props }) => {
  return (
    <button
      className="delete-row"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      title={disabled ? "Cannot delete - has references" : "Delete"}
      {...props}
    >
      <FontAwesomeIcon icon={faTrashCan} />
    </button>
  );
};

export default DeleteRowButton;

